/* tslint:disable */
/* eslint-disable */
/**
 * Revisdom API
 * Revisdom uygulaması için REST API dokümantasyonu
 *
 * The version of the OpenAPI document: v1
 * Contact: support@revisdom.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RevisdomAPIViewModelsSignInResponse
 */
export interface RevisdomAPIViewModelsSignInResponse {
    /**
     * 
     * @type {string}
     * @memberof RevisdomAPIViewModelsSignInResponse
     */
    title?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RevisdomAPIViewModelsSignInResponse
     */
    role?: RevisdomAPIViewModelsSignInResponseRoleEnum;
}


/**
 * @export
 */
export const RevisdomAPIViewModelsSignInResponseRoleEnum = {
    AccountManager0: 'Account Manager (0)',
    AccountOwner1: 'Account Owner (1)',
    InternalTeam2: 'Internal Team (2)',
    BrandAccountViewer3: 'Brand Account Viewer (3)',
    SperYnetici4: 'Süper Yönetici (4)',
    Guest5: 'Guest (5)'
} as const;
export type RevisdomAPIViewModelsSignInResponseRoleEnum = typeof RevisdomAPIViewModelsSignInResponseRoleEnum[keyof typeof RevisdomAPIViewModelsSignInResponseRoleEnum];


/**
 * Check if a given object implements the RevisdomAPIViewModelsSignInResponse interface.
 */
export function instanceOfRevisdomAPIViewModelsSignInResponse(value: object): value is RevisdomAPIViewModelsSignInResponse {
    return true;
}

export function RevisdomAPIViewModelsSignInResponseFromJSON(json: any): RevisdomAPIViewModelsSignInResponse {
    return RevisdomAPIViewModelsSignInResponseFromJSONTyped(json, false);
}

export function RevisdomAPIViewModelsSignInResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RevisdomAPIViewModelsSignInResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'title': json['title'] == null ? undefined : json['title'],
        'role': json['role'] == null ? undefined : json['role'],
    };
}

export function RevisdomAPIViewModelsSignInResponseToJSON(json: any): RevisdomAPIViewModelsSignInResponse {
    return RevisdomAPIViewModelsSignInResponseToJSONTyped(json, false);
}

export function RevisdomAPIViewModelsSignInResponseToJSONTyped(value?: RevisdomAPIViewModelsSignInResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'title': value['title'],
        'role': value['role'],
    };
}

